import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IApiListParams } from '@/types';
import { ICurrencyExchangeApiListResponse, ICurrencyExchangeCreateParams, ICurrencyExchangeMutationResponse } from '@/types/currencyExchange';

export const currencyExchangeList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<ICurrencyExchangeApiListResponse>> => {
    return axios.get('/api/currencyExchange/list', { ...config, params });
};

export const currencyExchangeCreate = (
    params: ICurrencyExchangeCreateParams,
    config?: AxiosRequestConfig
): Promise<AxiosResponse<ICurrencyExchangeMutationResponse>> => {
    return axios.post('/api/currencyExchange/create', params, config);
};
